module.exports = __webpack_public_path__ + "media/images/icons/left-arrow-12d661b7f4c0815d5cffbc4a2a299e2e.svg";